import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserProfileService } from '../http/user-profile.service';
import { Roles } from '../utils';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  appUser;
  initialzed = false;
  constructor(
    private router: Router,
    private userProfileService: UserProfileService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const allowedUserRoles = this.getRoutePermissions(route);
    const allowed =  await this.checkPermission(allowedUserRoles);
    if(!this.initialzed && !allowed){
      // logic to route user to permitted route..
      if(this.appUser.userRoles.filter(x => x.id === 3)){
        this.router.navigate(['admin/manage-users']);
      }
      this.initialzed = true;
    }
    return allowed;
  }

  /**
* Get allowed user roles from the route.
* @param {ActivatedRouteSnapshot} route - The route.
* @returns {string[]} All user roles that are allowed to access the route.
*/
  private getRoutePermissions(route: ActivatedRouteSnapshot): Roles[] {
    if (route.data && route.data.userRoles) {
      return route.data.userRoles as Roles[];
    }
    return null;
  }

  /**
   * Check if a user is authenticated
   * @param {string[]} allowedUserRoles - These user roles have the permissions to access the route.
   * @returns {Promise<boolean>} True if user is authenticated otherwise false
   */
  private checkPermission(allowedUserRoles: Roles[]): Promise<boolean> {
    return this.getAppUser().then((appUser: any) => {
      if (appUser) {
        if (!allowedUserRoles || allowedUserRoles.length === 0) {
          return true;   // if no user roles has been set, all user are allowed to access the route
        } else {
          if (appUser && this.areUserRolesAllowed(appUser.userRoles, allowedUserRoles)) {
            return true;
          } else {
            this.router.navigateByUrl('/unauthorized');
            return false;
          }
        }
      } else {
        this.router.navigateByUrl('/unauthorized');
        return true;
      }
    });
  }

  private getAppUser(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (!this.appUser) {
        this.userProfileService.getUserDetails()
          .subscribe(appUser => {
            localStorage.setItem('currentUser', JSON.stringify(appUser));
            this.appUser = appUser;
            return resolve(appUser);
          })
      } else {
        return resolve(this.appUser);
      }
    });
  }

  private areUserRolesAllowed(userRoles, allowedUserRoles: Roles[]): boolean {
    for (const role of userRoles) {
      for (const allowedRole of allowedUserRoles) {
        if (role.name.toLowerCase() === allowedRole.toLowerCase()) {
          return true;
        }
      }
    }
    return false;
  }
}
